// extracted by mini-css-extract-plugin
export default {"textarea":"textArea_textarea__5eIDz"};